import { useContext as o } from "react";
import { ButtonGroupContext as t } from "../ButtonGroupProvider.js";
const e = () => o(t);
export {
  e as useButtonGroup
};
